/* ============================================================
   THE FUDGE PIE CO · approved motion + behaviour, ported to Horizon
   ------------------------------------------------------------
   Port of fudge-homepage-preview/assets/site.js (approved 2026-08-04)
   plus the pie.html gallery/quantity script. Differences from source:
     · every design class carries the f- prefix (collision shield,
       see assets/fudge-site.css header)
     · divider colour blending reads data-above (server-rendered)
       before falling back to sibling sniffing
     · add-to-cart is real: .fudge-atc forms post to Shopify's cart,
       the oven animation plays on success, header count updates.
       With JS off the form submits normally to /cart.
   Everything degrades gracefully and respects prefers-reduced-motion.
   ============================================================ */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal failsafe ---- */
  (function(){
    var t = setTimeout(function(){
      document.querySelectorAll('.f-reveal:not(.f-in-view)').forEach(function(el){ el.classList.add('f-in-view'); });
    }, 2500);
    document.addEventListener('fpc:revealed', function(){ clearTimeout(t); }, { once:true });
  })();

  /* ---- Mobile nav toggle (hamburger) ---- */
  (function(){
    var header = document.querySelector('.f-header');
    var toggle = document.querySelector('.f-nav-toggle');
    if(!header || !toggle) return;
    toggle.addEventListener('click', function(){
      var open = header.classList.toggle('f-nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.f-links a').forEach(function(a){
      a.addEventListener('click', function(){ header.classList.remove('f-nav-open'); toggle.setAttribute('aria-expanded','false'); });
    });
  })();

  /* ---- SVG divider injection (crust crimp · whipped cream) ---- */
  var scallop = "a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 a16 22 0 0 1 -32 0 ";
  var crustPathBack  = "M0 8 H320 V30 " + scallop + "Z";
  var crustPathFront = "M0 0 H320 V22 " + scallop + "Z";

  var dvN = 0;
  function crustSVG(above){
    above = above || '#e3c187';
    var g = 'crg'+(++dvN);
    return '<svg viewBox="0 0 320 54" preserveAspectRatio="none" height="54" aria-hidden="true">'
      + '<defs><linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1">'
      +   '<stop offset="0" stop-color="'+above+'"/><stop offset="0.52" stop-color="#e3c187"/><stop offset="1" stop-color="#e3c187"/>'
      + '</linearGradient></defs>'
      + '<path d="'+crustPathBack+'" fill="#b98f52"/>'
      + '<path d="'+crustPathFront+'" fill="url(#'+g+')"/>'
      + '<g clip-path="url(#crustClip)"><rect width="320" height="54" filter="url(#grainCrust)" opacity=".34"/></g>'
      + '</svg>';
  }
  function creamSVG(above){
    above = above || '#f1e6d2';
    var g = 'cmg'+(++dvN);
    var w=1240, base=22, h=70, step=68, rs=[34,39,37,41,36,38], puffs=[], i=0, x;
    for(x=step*0.5; x<=w; x+=step, i++){ puffs.push({x:x, r:rs[i%rs.length]}); }
    var s='<svg viewBox="0 0 '+w+' '+h+'" preserveAspectRatio="none" height="'+h+'" aria-hidden="true">';
    s+='<defs><linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1">'
      +'<stop offset="0" stop-color="'+above+'"/><stop offset="0.36" stop-color="#ffffff"/><stop offset="1" stop-color="#f1e6d2"/>'
      +'</linearGradient></defs>';
    s+='<g opacity="0.4">';
    puffs.forEach(function(p){ s+='<circle cx="'+(p.x+2)+'" cy="'+(base+3)+'" r="'+p.r+'" fill="#d6c4a1"/>'; });
    s+='</g>';
    s+='<g filter="url(#softsh)">';
    puffs.forEach(function(p){
      s+='<circle cx="'+p.x+'" cy="'+(base-2)+'" r="'+p.r+'" fill="url(#'+g+')"/>';
    });
    s+='</g>';
    puffs.forEach(function(p){
      var r=p.r, cx=p.x;
      s+='<path d="M'+(cx-r*0.74).toFixed(1)+' '+(base+r*0.12).toFixed(1)+' Q'+cx+' '+(base+r*0.72).toFixed(1)+' '+(cx+r*0.74).toFixed(1)+' '+(base+r*0.12).toFixed(1)+'" stroke="#e4d3b3" stroke-width="1.8" fill="none" stroke-linecap="round" opacity="0.8"/>';
      s+='<path d="M'+(cx-r*0.5).toFixed(1)+' '+(base+r*0.48).toFixed(1)+' Q'+cx+' '+(base+r*0.98).toFixed(1)+' '+(cx+r*0.5).toFixed(1)+' '+(base+r*0.48).toFixed(1)+'" stroke="#e4d3b3" stroke-width="1.4" fill="none" stroke-linecap="round" opacity="0.6"/>';
      s+='<path d="M'+(cx-r*0.5).toFixed(1)+' '+(base+r*0.16).toFixed(1)+' Q'+(cx-r*0.05).toFixed(1)+' '+(base+r*0.52).toFixed(1)+' '+(cx+r*0.36).toFixed(1)+' '+(base+r*0.18).toFixed(1)+'" stroke="#ffffff" stroke-width="2.1" fill="none" stroke-linecap="round" opacity="0.85"/>';
    });
    s+='<rect x="0" y="0" width="'+w+'" height="'+base+'" fill="url(#'+g+')"/>';
    s+='</svg>';
    return s;
  }
  function sectionColor(el){
    if(!el) return '#FBF5EA';
    var c = el.className || '';
    if(/f-sec--brown2|\bf-care\b/.test(c)) return '#7A3A1D';
    if(/f-sec--brown\b|f-baking-head|\bf-join\b/.test(c)) return '#551900';
    if(/\bf-holiday\b/.test(c)) return '#4d1802';
    if(/f-sec--cream|\bf-reviews\b|\bf-baking\b/.test(c)) return '#F3E7D3';
    if(/\bf-hero\b/.test(c)) return '#e6d3b0';
    var bg = getComputedStyle(el).backgroundColor;
    return (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') ? bg : '#FBF5EA';
  }
  document.querySelectorAll('[data-divider]').forEach(function(el){
    var t = el.getAttribute('data-divider');
    var above = el.getAttribute('data-above') || sectionColor(el.previousElementSibling);
    el.innerHTML = t === 'cream' ? creamSVG(above) : crustSVG(above);
  });

  /* ---- Scroll reveal ---- */
  document.dispatchEvent(new Event('fpc:revealed'));
  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.f-reveal').forEach(function(el){ el.classList.add('f-in-view'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('f-in-view'); io.unobserve(e.target); } });
    }, { threshold:0.12, rootMargin:'0px 0px -8% 0px' });
    document.querySelectorAll('.f-reveal').forEach(function(el){ io.observe(el); });
  }

  /* ---- Cursor-reactive paper-cut tilt ---- */
  if (!reduce) {
    document.querySelectorAll('.f-tilt').forEach(function(tilt){
      var inner = tilt.querySelector('.f-tilt-in');
      if (!inner) return;
      var str = parseFloat(tilt.getAttribute('data-tilt')) || 12;
      var base = inner.classList.contains('f-keepsake') ? -1.4
               : inner.classList.contains('f-story-in') ? 1.2 : 0;
      tilt.addEventListener('pointermove', function(e){
        var r = tilt.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = 'rotate(' + base + 'deg) rotateX(' + (-y*str*0.8).toFixed(2) + 'deg) rotateY(' + (x*str).toFixed(2) + 'deg) scale(1.015)';
      });
      tilt.addEventListener('pointerleave', function(){ inner.style.transform = base ? 'rotate('+base+'deg)' : ''; });
    });

    document.querySelectorAll('.f-pcard, .f-scard').forEach(function(card){
      var slice = card.querySelector('.f-pie-slice');
      var gap = card.querySelector('.f-pie-gap');
      card.addEventListener('pointerenter', function(){
        if (slice) slice.style.transform = 'translate(9px,-7px)';
        if (gap) gap.style.opacity = '1';
      });
      card.addEventListener('pointerleave', function(){
        if (slice) slice.style.transform = '';
        if (gap) gap.style.opacity = '';
      });
    });
  }
  document.querySelectorAll('.f-pie-slice').forEach(function(s){ s.style.transition = 'transform .45s cubic-bezier(.34,1.56,.64,1)'; });
  document.querySelectorAll('.f-pie-gap').forEach(function(g){ g.style.opacity='0'; g.style.transition='opacity .3s ease .1s'; });

  /* ---- Into-the-oven add to cart (real: posts to Shopify cart) ---- */
  function ovenAnimate(btn){
    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';
    if (btn.classList.contains('f-baking')) return;
    btn.classList.add('f-baking');
    if (label) label.textContent = 'Into the oven';
    setTimeout(function(){ btn.classList.add('f-donebake'); if (label) label.textContent = 'In the box ✓'; }, 850);
    setTimeout(function(){ btn.classList.remove('f-baking','f-donebake'); if (label) label.textContent = original; }, 2500);
  }
  function setCartCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(b){
      b.textContent = n;
      if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden',''); }
    });
  }
  document.querySelectorAll('form.fudge-atc').forEach(function(form){
    form.addEventListener('submit', function(e){
      if (!window.fetch || !window.FormData) return;   // no-JS-era fallback: normal POST
      e.preventDefault();
      var btn = form.querySelector('.f-cart-btn');
      if (btn && btn.classList.contains('f-baking')) return;
      fetch(form.action + '.js', { method:'POST', body:new FormData(form), headers:{ 'Accept':'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){ return fetch('/cart.js', { headers:{ 'Accept':'application/json' } }); })
        .then(function(r){ return r.json(); })
        .then(function(cart){ setCartCount(cart.item_count); if (btn) ovenAnimate(btn); })
        .catch(function(){ form.submit(); });          // network hiccup: let Shopify handle it
    });
  });

  /* ---- Flavor filter pills (shop page / seasonal menu) ---- */
  (function(){
    var pills = [].slice.call(document.querySelectorAll('.f-fpill[data-filter]'));
    var cards = [].slice.call(document.querySelectorAll('.f-pcard[data-category]'));
    if (!pills.length || !cards.length) return;

    function categoriesOf(card){ return (card.dataset.category || '').split(/\s+/).filter(Boolean); }

    pills.forEach(function(pill){
      var key = pill.dataset.filter;
      var n = cards.filter(function(c){ return categoriesOf(c).indexOf(key) !== -1; }).length;
      var countEl = pill.querySelector('.f-count');
      if (countEl) countEl.textContent = n;
      if (n === 0 && key !== 'in-season') pill.setAttribute('hidden','');
    });

    function applyFilter(key){
      cards.forEach(function(card){
        var match = categoriesOf(card).indexOf(key) !== -1;
        card.style.display = match ? '' : 'none';
      });
    }

    pills.forEach(function(pill){
      pill.addEventListener('click', function(){
        pills.forEach(function(p){ p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
        applyFilter(pill.dataset.filter);
      });
    });

    var initial = pills.filter(function(p){ return p.getAttribute('aria-pressed') === 'true'; })[0] || pills[0];
    applyFilter(initial.dataset.filter);
  })();

  /* ---- Scroll host ----
     Horizon scrolls inside .page-wrapper, not the document, so window
     'scroll' never fires and window.scrollY is permanently 0. Everything
     scroll-aware below listens here and works off viewport coordinates,
     which are correct whichever element is doing the scrolling. */
  var scrollHost = document.querySelector('.page-wrapper') || window;

  /* ---- Light parallax for depth layers ---- */
  if (!reduce) {
    var pxEls = [].slice.call(document.querySelectorAll('.f-parallax'));
    if (pxEls.length) {
      var ticking = false;
      scrollHost.addEventListener('scroll', function(){
        if (ticking) return; ticking = true;
        requestAnimationFrame(function(){
          var vh = window.innerHeight;
          pxEls.forEach(function(el){
            var r = el.getBoundingClientRect();
            var mid = r.top + r.height/2;
            var off = (mid - vh/2) * (parseFloat(el.getAttribute('data-speed')) || 0.05);
            el.style.transform = 'translateY(' + (-off).toFixed(1) + 'px)';
          });
          ticking = false;
        });
      }, { passive:true });
    }
  }

  /* ---- Cartoon chocolate chips that pop toward the cursor ---- */
  (function(){
    var fields = [].slice.call(document.querySelectorAll('.f-chipfield'));
    if (!fields.length) return;
    var chipSVG = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M9 36 C6 36 4.6 33.4 5.4 30.2 C7.4 21 11 12.5 16.5 6.5 C18.4 4.4 20.6 3.4 22.2 4.4 C24 5.5 24.4 7.8 22.8 9.2 C21.8 10.1 22.3 11.5 23.6 11.6 C27 12 30.5 22 34 30 C35.3 32.9 33.6 36 30.6 36 Z" fill="url(#chipG)"/><path d="M11.6 31 C13.2 22.5 16.2 13.6 20 8.2" stroke="#a5642f" stroke-width="3" stroke-linecap="round" fill="none" opacity=".55"/></svg>';
    var all = [];
    fields.forEach(function(field){
      var cols = parseInt(field.dataset.cols,10) || 8;
      var rows = parseInt(field.dataset.rows,10) || 5;
      for (var r=0; r<rows; r++){
        for (var c=0; c<cols; c++){
          var el = document.createElement('span');
          el.className = 'f-choco-chip';
          var jx = Math.sin(r*3.1 + c*1.7) * 2.6;
          var jy = Math.cos(c*2.3 + r*1.3) * 3.2;
          el.style.left = (4 + c * (92/(cols-1)) + jx).toFixed(2) + '%';
          el.style.top  = (8 + r * (84/(rows-1)) + jy).toFixed(2) + '%';
          el.innerHTML = chipSVG;
          field.appendChild(el);
          all.push({ el:el, field:field, cx:0, cy:0, rot:(Math.sin(r*1.7+c*0.9)*14).toFixed(1) });
        }
      }
    });
    all.forEach(function(o){ o.el.style.transform = 'rotate('+o.rot+'deg) scale(.5)'; o.t = 0; });
    if (reduce){ all.forEach(function(o){ o.el.style.opacity = '.14'; }); return; }

    /* Geometry is measured per FIELD (a handful of rects), never per chip
       (hundreds), and in viewport coordinates so it stays correct no matter
       which element is doing the scrolling. Offsets inside a field are
       static, so they are cached once and never re-measured. */
    var fieldList = fields.map(function(f){ return { el:f, chips:[] }; });
    all.forEach(function(o){
      var entry = fieldList.filter(function(f){ return f.el === o.field; })[0];
      o.ox = o.el.offsetLeft + o.el.offsetWidth/2;
      o.oy = o.el.offsetTop  + o.el.offsetHeight/2;
      entry.chips.push(o);
    });

    var R = 190, mx = -99999, my = -99999, tick = false;
    function render(){
      tick = false;
      var vh = window.innerHeight, vw = window.innerWidth;
      for (var f=0; f<fieldList.length; f++){
        var fl = fieldList[f];
        var r = fl.el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200 || r.right < 0 || r.left > vw) continue;
        var near = my > r.top - R && my < r.bottom + R && mx > r.left - R && mx < r.right + R;
        for (var i=0; i<fl.chips.length; i++){
          var o = fl.chips[i], t = 0;
          if (near){
            var dx = mx - (r.left + o.ox), dy = my - (r.top + o.oy);
            var d = Math.sqrt(dx*dx + dy*dy);
            t = d < R ? 1 - d/R : 0;
            t = t*t*(3 - 2*t);
          }
          if (Math.abs(t - o.t) < 0.01) continue;   // skip DOM writes that change nothing
          o.t = t;
          o.el.style.transform = 'rotate('+o.rot+'deg) scale(' + (0.5 + t*1.2).toFixed(3) + ')';
          o.el.style.opacity = (0.1 + t*0.5).toFixed(3);
        }
      }
    }
    window.addEventListener('pointermove', function(e){
      mx = e.clientX; my = e.clientY;
      if (!tick){ tick = true; requestAnimationFrame(render); }
    }, { passive:true });
    document.addEventListener('mouseleave', function(){ mx = my = -99999; requestAnimationFrame(render); });
  })();

  /* ---- Product page: gallery thumbs + quantity stepper (real form sync) ---- */
  (function(){
    var main = document.getElementById('pdpMain');
    if (main) {
      document.querySelectorAll('.f-pdp-thumbs button').forEach(function(b){
        b.addEventListener('click', function(){
          document.querySelectorAll('.f-pdp-thumbs button').forEach(function(x){ x.setAttribute('aria-current','false'); });
          b.setAttribute('aria-current','true');
          main.src = b.getAttribute('data-full');
          main.alt = b.querySelector('img').alt;
        });
      });
    }
    var qtyBox = document.querySelector('.f-qty');
    if (qtyBox) {
      var q = qtyBox.querySelector('output'), n = 1;
      var hidden = document.querySelector('form.fudge-atc input[name="quantity"]');
      var btns = qtyBox.querySelectorAll('button');
      function sync(){ q.textContent = n; if (hidden) hidden.value = n; }
      if (btns.length === 2) {
        btns[0].addEventListener('click', function(){ if (n > 1) { n--; sync(); } });
        btns[1].addEventListener('click', function(){ if (n < 12) { n++; sync(); } });
      }
    }
  })();
})();
